import z from "zod";

export const getTransferCarrierParamSchema = z.object({
	transferCarrierId: z.uuid(),
});

export type GetTransferCarrierParamSchema = z.infer<typeof getTransferCarrierParamSchema>;

/**
 * One scan of a transfer carrier — the trolley that walks returned material from the goods-in door
 * to the shelf it belongs on.
 *
 * The code is **either** the carrier's uuid, from a printed QR, **or** the plain number painted on
 * the device. Both are real: a QR is how the rest of the domain identifies a physical object, and
 * the painted number is the label a yard already has — `set_scoped_transfer_carrier_number` exists
 * so a fleet labelled before the software did keeps its own numbers, and refusing to scan those
 * would make that pointless.
 *
 * It is a `POST` despite reading nothing but the carrier and its loads, because a code belongs in
 * a body rather than in a URL that lands in every access log along the way.
 */
export const postTransferCarrierScanSchema = z.object({
	code: z.string().min(1),
});

export type PostTransferCarrierScanSchema = z.infer<typeof postTransferCarrierScanSchema>;
